import nlc from '../abis/production/tokens/nlcToken';

export default {
  name: 'NLC',
  abi: nlc.abi,
  contractAddress: '0x0260a326cA2d49C981eaa0335C4551d0B4216227',
  decimals: 18,
};
